import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import promotionalImage from "../../../../Assets/vendor/promotion.jpg";

export default function IncomeEstimationPage() {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    return (
        <div className="min-h-screen bg-gradient-to-b from-[#6c548f] to-[#d97aff] flex flex-col text-black font-satoshi">
            {/* Top section */}
            <div className="p-6 text-white text-center">
                <h1 className="font-bold mb-2 sm:text-sm md:text-xl"></h1>
            </div>

            {/* Content section */}
            <div className="bg-white rounded-t-3xl -mt-4 flex-1 flex flex-col items-center justify-between px-4 py-6">
                {/* Image */}
                <div className="w-full mb-3 flex justify-center items-center overflow-hidden">
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vendor/promotion.jpg' alt="promotional" className="max-w-full max-h-full object-contain" />
               all </div>

                {/* Buttons */}
                <div className="w-full flex gap-4 items-center">
                    <button
                        onClick={() => setShowModal(true)}
                        className="w-[90%] bg-[#00bdff] text-white py-3 rounded-xl font-semibold text-lg"
                    >
                        View Tutorial
                    </button>
                    <button
                        onClick={() => navigate("/Submit-images")}
                        className="w-[90%] bg-red-400 text-white py-3 rounded-xl font-semibold text-lg"
                    >
                        Continue
                    </button>
                </div>
            </div>

            {/* Modal */}
            {showModal && (
                <div  onClick={() => setShowModal(false)} className="fixed inset-0 bg-[rgb(219_210_210_/_91%)] bg-opacity-60 z-50 flex items-center justify-center px-4">
                     
                    <div className="relative bg-white rounded-2xl shadow-xl max-w-3xl w-full overflow-hidden">
                        {/* Close Button */}
                        <button
                            onClick={() => setShowModal(false)}
                            className="absolute top-3 right-3 text-black hover:text-gray-800 z-10"
                        >
                            <X size={24} />
                        </button>

                        {/* Video */}
                        <div className="aspect-w-16 aspect-h-9 w-full">
                            <iframe
                                className="w-full h-full"
                                src="https://www.youtube.com/embed/qmUlSNG5xKg"
                                title="Tutorial Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
